<form [formGroup]="form">
  <div class="pwList text-start"> {{'lang.passwordReset.pwInclude'|translate}}:
    <div>
      {{'lang.passwordReset.minLength'|translate}}:
      <input type="number" id="min" class="form-control" formControlName="min">
    </div>
    <div>
      {{'lang.passwordReset.maxLength'|translate}}:
      <input type="number" id="max" class="form-control" formControlName="max">
    </div>
    <div>
      {{'lang.passwordReset.upperCase'|translate}}:
      <input type="number" id="upper" class="form-control" formControlName="upper">
    </div>
    <div>
      {{'lang.passwordReset.lowerCase'|translate}}:
      <input type="number" id="lower" class="form-control" formControlName="lower">
    </div>
    <div>
      {{'lang.passwordReset.special'|translate}}:
      <input type="number" id="special" class="form-control" formControlName="special">
    </div>
    <div>
      {{'lang.passwordReset.number'|translate}}:
      <input type="number" id="num" class="form-control" formControlName="num">
    </div>
    <div>
      {{'lang.passwordReset.space'|translate}}:
      <input type="number" id="space" class="form-control" formControlName="space">
    </div>
  </div>
</form>
